import { Button } from '@mui/material';
import { useAuthenticationService } from '@pn/services/authentication';
import { useLocation } from 'react-router-dom';

export function AuthButton() {
  const { pathname, search } = useLocation();
  const { isAuthenticated, login } = useAuthenticationService();

  if (!isAuthenticated) {
    return (
      <Button
        onClick={() => login({ returnTo: pathname + search })}
        size={'small'}
      >
        Login
      </Button>
    );
  }
}
